const Links = {

    // Riksbyggen links
    RB_RIKSBYGGEN: "https://www.riksbyggen.se/",
    RB_COOKIES: "https://www.riksbyggen.se/integritet/cookies/",
    RB_INTEGRITY_POLICY: "https://www.riksbyggen.se/integritet/",
    RB_ABOUT_US: "https://www.riksbyggen.se/om-webbplatsen/",
    RB_USE_TERMS: "https://www.riksbyggen.se/villkor-digitala-tjanster/",
    RB_PRIVACY_TERMS: "https://www.riksbyggen.se/integritet/",

    // DUP specifics links
    DUP_READ_MORE: "https://www.riksbyggen.se/digital-underhallsplan/",
    DUP_PURCHASE_TERMS: "https://mitt.riksbyggen.se/prenumerationstjanst/kopvillkor-digital-underhallsplan/",
    DUP_OFFER: "https://www.riksbyggen.se/fastighetsforvaltning/digital-underhallsplan/offert-ombyggnad/",

    //Social media links
    SOCIAL_FACEBOOK: "https://www.facebook.com/Riksbyggen",
    SOCIAL_X: "https://x.com/Riksbyggen",
    SOCIAL_YOUTUBE: "https://www.youtube.com/channel/UCQNj2h1PTYeHNOLG63Q-74g",
    SOCIAL_LINKEDIN: "https://www.linkedin.com/company/riksbyggen/",
    SOCIAL_INSTAGRAM: "https://www.instagram.com/riksbyggen/",
} as const;

export default Links;